import { Unit } from './mealingredient';

// todo: replace with plain interface
export class ShoppingItem {
    public ingredientId: string;
    public quantity: number;
    public isCheckedFromShoppingList: boolean;
    public unit: Unit;
    public displayDescription: string;
    public category: string;
}
